
import React from "react";
import ReactDOM from 'react-dom';
import { SnackbarProvider } from "notistack";
import Snackbar from "./Snackbar";

export default function Feedback({ data: { siteName, messages } })
{
    return (
        <SnackbarProvider>
            <Snackbar messages={messages} siteName={siteName} />
        </SnackbarProvider>
    )
}



const container = document.getElementById('server-feedback')

if (container)
{
    const data = Object.assign({}, container.dataset);
    ReactDOM.render(<Feedback data={JSON.parse(data.data)} />, container);
}


// WEBPACK FOOTER //
// ./resources/js/react/components/Snackbar/index.js